var render = function render(_c,_vm){return _c('div',{staticClass:"spinner-content"},[_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","fill":"none","r":"20","stroke-width":"5"}})]),_c('span',[_vm._v("Loading...")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }